export const formatValueCompliance = (value) => {
    // Remove qualquer caracter não alfanumérico
    value = value.replace(/[^A-Za-z0-9]/g, "");

    // Aplica a máscara
    if (value.length <= 3) {
        return value.toUpperCase(); 
    } else if (value.length <= 7) {
        return value.slice(0, 3).toUpperCase() + '-' + value.slice(3); 
    } else if (value.length <= 11) {
        return value.slice(0, 3).toUpperCase() + '-' + value.slice(3, 7) + '-' + value.slice(7, 10);
    }
    return value.slice(0, 11); 
};